import { formatTruncatePriceWithCurrency } from '../../Formatters/AssetFormatter';
import { OperationType } from '../../Trading/OperationType';
import { ColumnTotalVisibility } from '../TableColumn.interface';
import { getCurrencyValue, isCurrencyColumn, isQuantityColumn } from './PositionTableData';
import { TableQuantityTotalMode } from '../Totals/TableQuantityTotalMode.types';
import { TableTotalsSummaryService } from '../Totals/TableTotalSummaryService';
export class PositionsTableTotalService {
    get tableQuantityTotalMode() {
        return this._tableQuantityTotalMode;
    }
    set tableQuantityTotalMode(value) {
        if (this._tableQuantityTotalMode === value) {
            return;
        }
        this._tableQuantityTotalMode = value;
        this._storage.updateTotals();
    }
    constructor(storage) {
        this._tableQuantityTotalMode = TableQuantityTotalMode.Total;
        this.calculate = (column, rows) => {
            if (column.totalVisibility === ColumnTotalVisibility.None) {
                return NaN;
            }
            if (isQuantityColumn(column.id)) {
                return this._tableQuantityTotalMode === TableQuantityTotalMode.Net
                    ? this.calculateQuantityNetTotal(column, rows)
                    : TableTotalsSummaryService.calculate(column, rows);
            }
            else if (isCurrencyColumn(column.id)) {
                return this.calculateCurrencyTotal(column, rows);
            }
            else {
                return TableTotalsSummaryService.calculate(column, rows);
            }
        };
        this.format = (column, rows, value) => {
            if (isNaN(value)) {
                return '';
            }
            if (isQuantityColumn(column.id)) {
                return this.formatQuantityValue(column, rows, value);
            }
            else if (isCurrencyColumn(column.id)) {
                return this.formatCurrencyValue(column, rows, value);
            }
            return value.toString();
        };
        this._storage = storage;
    }
    // #region Quantity Columns
    calculateQuantityNetTotal(column, rows) {
        let sum = 0;
        for (const row of rows) {
            const value = row.data.getValue(column.id);
            if (isValidNumber(value)) {
                const position = this._storage.getPositionOrCorporateAction(row);
                if (position === null) {
                    continue;
                }
                const operationType = position.getOperationType();
                const amountLots = position.getAmountLots();
                let sign = operationType === OperationType.Buy ? 1 : -1;
                if (amountLots < 0 && sign < 0) {
                    sign = 1;
                }
                sum += value * sign;
            }
        }
        return sum;
    }
    formatQuantityValue(_column, _rows, value) {
        return value.toFixed(2);
    }
    // #endregion Quantity Columns
    // #region Currency Columns
    calculateCurrencyTotal(column, rows) {
        const isUseAccountCurrency = this.isUseAccountCurrency(rows);
        let sum = 0;
        for (const row of rows) {
            const position = this._storage.getPositionOrCorporateAction(row);
            if (position === null) {
                continue;
            }
            const value = getCurrencyValue(position, column.id, isUseAccountCurrency);
            if (isValidNumber(value)) {
                sum += value;
            }
        }
        return sum;
    }
    formatCurrencyValue(_column, rows, value) {
        const asset = this.getFormatAsset(rows);
        if (isNullOrUndefined(asset)) {
            return value.toFixed(2);
        }
        else {
            return formatTruncatePriceWithCurrency(value, asset);
        }
    }
    isUseAccountCurrency(rows) {
        if (rows.length <= 1) {
            return true;
        }
        let asset = null;
        for (const row of rows) {
            const position = this._storage.getPositionOrCorporateAction(row);
            if (position === null) {
                continue;
            }
            const account = position.getAccount();
            if (isNullOrUndefined(account)) {
                continue;
            }
            const accountAsset = account.getAsset();
            if (isNullOrUndefined(accountAsset)) {
                continue;
            }
            if (isNullOrUndefined(asset)) {
                asset = accountAsset;
                continue;
            }
            if (asset !== accountAsset) {
                return false;
            }
        }
        return true;
    }
    getFormatAsset(rows) {
        const isUseAccountCurrency = this.isUseAccountCurrency(rows);
        for (const row of rows) {
            const position = this._storage.getPositionOrCorporateAction(row);
            if (position === null) {
                continue;
            }
            const account = position.getAccount();
            if (isNullOrUndefined(account)) {
                continue;
            }
            const asset = isUseAccountCurrency ? account.getAsset() : account.getServerAsset();
            if (isNullOrUndefined(asset)) {
                continue;
            }
            return asset;
        }
        return null;
    }
}
